import * as React from 'react';
import axios from 'axios';
import { CustomerV2, CustomerType } from './iMonCompte';
import {
  renderFilArianne, renderAlert, renderLabel, renderInput, renderTitleH1, inputColorWhenError,
  inputColorWhenNoError
} from './RenderCommon';
import { getUserId, sessionExpire } from './MonCompteAction';
import { getHostApi, getRequestConfig, initEvent } from '../../utils';
import Modal from 'react-responsive-modal';
import Icons from "./Icons";
import PasswordInfosForm from "../tunnel/PasswordInfosForm";
import { fetchCustomerTypes } from '../../service/shop.api';
import { fetchCustomerByIdV2, updateCustomerV2 } from '../../service/customer.api';

interface RenderProfilState {
  customer: CustomerV2;
  oldPassword?: string;
  newPassword?: string,
  confirmPassword?: string;
  confirmEmail: string;
  oldEmail: string;
  showAlert: boolean;
  textAlert: string;
  classAlert: string;
  transporteurs: any[];
  offresPromotionnelles: boolean;
  cgv: boolean;
  politiqueConfidentialite: boolean;
  cmdEnCours: boolean;
  modal: boolean;
  modalContent: string;
  activateContratsRGPD: boolean;
  contrats: any[];
  majLockMode: boolean;
  majLockModeConf: boolean;
  listCustomerTypes: CustomerType[];
}

export default class RenderProfil extends React.Component<Record<string, unknown>, RenderProfilState> {
  private displayPasswordInfos: boolean;
  private passwordInfos: any;
  private featurePassword: boolean;
  private showHidePassword: boolean;
  constructor(props: Record<string, unknown>) {
    super(props);
    this.state = {
      customer: {
        id: 0,
        superId: null,
        firstname: '',
        lastname: '',
        email: '',
        customerType: {
          id: 0,
          label: ''
        }
      },
      showAlert: false,
      textAlert: 'Votre adresse a bien été mise à jour',
      classAlert: 'alert-success',
      newPassword: undefined,
      confirmEmail: '',
      oldEmail: '',
      transporteurs: [],
      offresPromotionnelles: false,
      cgv: false,
      politiqueConfidentialite: false,
      cmdEnCours: false,
      modal: false,
      modalContent: '',
      activateContratsRGPD: false,
      contrats: [],
      majLockMode: false,
      majLockModeConf: false,
      listCustomerTypes: []
    };
    this.onOpenModal = this.onOpenModal.bind(this);
    this.displayPasswordInfos = false;
    this.featurePassword = false;
    this.showHidePassword = false;
    this.passwordInfos = {};
  }

  /**
   * Fonction retournant un utilisateur
   *
   * @returns {Order[]}
   * @private
   */
  _getCustomer() {
    document.dispatchEvent(initEvent('dp-loading'));
    Promise.all([
      fetchCustomerByIdV2(),
      fetchCustomerTypes()
    ])
      .then(([responseUser, responseCustomerType]) => {
        if (responseUser.data.data) {
          this.setState({
            customer: responseUser.data.data,
            oldEmail: responseUser.data.data.email,
          });
        }
        this.setState({ listCustomerTypes: responseCustomerType.data.data });
      })
      .catch(error => {
        if (error.response.status === 401) {
          sessionExpire();
        }
      })
      .finally(() => document.dispatchEvent(initEvent('dp-loaded')));
  }

  /**
   *
   * @private
   */
  _getTransporteurs() {
    axios.get(`${getHostApi()}/shops/transporteurs`, getRequestConfig())
      .then((res) => {
        if (res.data.transporteurs) {
          this.setState({
            transporteurs: res.data.transporteurs,
          });
        }
      }).catch((err) => {
        console.error(err);
      });
  }

  /**
   * Récupère l'état de la feature Compte_rgpd_contrats
   * @private
   */
  _getFeatureContratsRGPD() {
    axios.get(`${getHostApi()}/shops/features/compte_contrats_rgpd`, getRequestConfig()).then((response) => {
      this.setState({ activateContratsRGPD: response.data.feature }, () => {
        if (this.state.activateContratsRGPD) {
          this._getStatutContrats();
        }
      });
    }).catch((error) => {
      console.log(error);
    });
  }

  /**
   * Récupère les contrats du client et pré-coche les cases si les contrats ont déjà été validés
   * @private
   */
  _getStatutContrats() {
    axios.get(`${getHostApi()}/customers/${getUserId()}/contrats`, getRequestConfig())
      .then((res) => {
        if (res.data) {
          const values: any = { ...this.state.contrats };
          this.setState({
            contrats: values,
            cmdEnCours : res.data.cmdEnCours,
          });
        }
      }).catch((err) => {
        console.error(err);
      });
  }

  /**
   * Met à jour les contrats cochés
   * @private
   */


  _updateStatutContrats() {
    const data: any = {};
    for (const [key, elt] of Object.entries(this.state.contrats)) {
      data[key] = elt['accepted'];
    }
    axios.post(`${getHostApi()}/customers/${getUserId()}/contrats`,
      data, getRequestConfig())
        .catch((error) => {
          console.error(error);
        });
  }

  /**
   * Fonction mettant à jour le profil du client connecté
   *
   * @param {React.MouseEvent<HTMLButtonElement>} event
   * @private
   */
  _updateProfil = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    if (this.state.customer.firstname === '' || this.state.customer.lastname === '' || this.state.customer.email === '') {
      this.setState({
        showAlert: true,
        textAlert: 'Veuillez renseigner les champs obligatoires ',
        classAlert: 'alert-danger',
      });
      this._colorEmptyRequiredInput();
    } else {
      if (this.state.confirmPassword === this.state.newPassword) {
        updateCustomerV2({
          firstname: this.state.customer.firstname,
          lastname: this.state.customer.lastname,
          email: this.state.customer.email,
          oldPassword: this.state.oldPassword ?? null,
          newPassword: this.state.newPassword ?? null,
          customerTypeId: this.state.customer.customerType.id ?? null
        })
          .then(() => {
            this._colorRequiredInput();
            inputColorWhenNoError('password');
            inputColorWhenNoError('confirmPassword');
            this.setState({
              showAlert: true,
              textAlert: 'Vos données personnelles ont bien été mises à jour ',
              classAlert: 'alert-success',
            });
            if (this.state.activateContratsRGPD) {
              this._updateStatutContrats();
            }
            this._majProfil(true);
          }).catch((error) => {
            this.setState({
              showAlert: true,
              textAlert: error.response.data.message,
              classAlert: 'alert-danger',
            });
          });
      } else {
        if (((this.state.confirmPassword?.length as number) < 8 && !this.featurePassword)) {
          this.setState({
            showAlert: true,
            textAlert: 'Le mot de passe doit contenir au moins 8 caractères ',
            classAlert: 'alert-danger',
          });
        } else if(this.featurePassword && this.state.confirmPassword === this.state.newPassword){
          this.setState({
            showAlert: true,
            textAlert: 'Le mot de passe ne répond pas aux critères ',
            classAlert: 'alert-danger',
          });
          inputColorWhenError('password');
          inputColorWhenError('confirmPassword');
        } else {
          this.setState({
            showAlert: true,
            textAlert: 'Les mots de passe ne sont pas identiques ',
            classAlert: 'alert-danger',
          });
          this._majProfil(true);
          inputColorWhenError('password');
          inputColorWhenError('confirmPassword');
        }
      }
    }
  }

  _colorEmptyRequiredInput = () => {
    this._colorRequiredInput();
    if (this.state.customer.lastname === '') {
      inputColorWhenError('lastname');
    }
    if (this.state.customer.firstname === '') {
      inputColorWhenError('firstname');
    }
    if (this.state.customer.email === '') {
      inputColorWhenError('email');
    }
  }

  _colorRequiredInput = () => {
    if (this.state.customer.lastname != '') {
      inputColorWhenNoError('lastname');
    }
    if (this.state.customer.firstname != '') {
      inputColorWhenNoError('firstname');
    }
    if (this.state.customer.email != '') {
      inputColorWhenNoError('email');
    }
  }

  /**
   * Fonction mettant à jour le state customer en fonction des valeurs saisies dans le formulaire
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event
   * @private
   */
  _onUpdateInput = (event: React.ChangeEvent<HTMLSelectElement> | React.ChangeEvent<HTMLInputElement>) => {
    const target = event.target;
    const name = target.name;
    const value = target.value;

    if (this.featurePassword && name === 'newPassword') {
      this.verifPassword(value);
      this.displayPasswordInfos = true;
    }

    if (name === 'confirmPassword' || name === 'newPassword' || name === 'oldPassword' || name === 'confirmEmail') {
      this.setState({ [name]: value });
    } else {
      this.setState({
        customer: { ...this.state.customer, [name]: value },
      });
    }
  }

  private verifPassword (password: string, returnValue: boolean = false) : void | boolean {
    let checkBoxLength = false;
    let checkBoxMaj = false;
    let checkBoxMin = false;
    let checkBoxChiffre = false;

    if(password.length >= 8 && password.length <= 30) {
      checkBoxLength = true;
    }
    if(password.match(/[A-ZÀ-ÖØ-Ý]/)) {
      checkBoxMaj = true;
    }
    if(password.match(/[a-zà-öø-ÿ]/)) {
      checkBoxMin = true;
    }
    if(password.match(/[0-9]/)) {
      checkBoxChiffre = true;
    }
    if((!checkBoxLength || !checkBoxMaj || !checkBoxMin || !checkBoxChiffre) && returnValue) {
      return true;
    }

    this.passwordInfos = {
      "checkBoxLength":checkBoxLength,
      "checkBoxMaj":checkBoxMaj,
      "checkBoxMin":checkBoxMin,
      "checkBoxChiffre":checkBoxChiffre
    };

  }

  _onCheckedInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const target = event.target;
    const name = target.name;
    const value = target.checked;
    const contrats = name.split('|');
    const values: any = { ...this.state.contrats };
    Array.from(contrats).forEach((contrat) => {
      values[contrat]['accepted'] = value;
    });
    this.setState({
      contrats: values,
    });
  }

  _majProfil  = (loaded: boolean) => {
    if (loaded) {
      document.getElementById('intituleBtn')?.classList.remove('d-none');
      document.getElementById('loaderBtn')?.classList.add('d-none');
    } else {
      document.getElementById('intituleBtn')?.classList.add('d-none');
      document.getElementById('loaderBtn')?.classList.remove('d-none');
    }
  }

  _isEmailValid = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    this._majProfil(false);

    if (this.state.confirmEmail === this.state.customer.email) {
      axios.post(
        `${getHostApi()}/customers/emails/validate`,
        { email: this.state.customer.email, idClient: this.state.customer.id },
        getRequestConfig()).then((response) => {
          if (response.data.valid.syntax === false) {
            this.setState({
              showAlert: true,
              textAlert: 'Le format de l\'email n\'est pas valide',
              classAlert: 'alert-danger',
            });
            inputColorWhenError('email');
          } else if (response.data.valid.available === false) {
            this.setState({
              showAlert: true,
              textAlert: 'Ce nom de domaine n\'existe pas',
              classAlert: 'alert-danger',
            });
            inputColorWhenError('email');
          } else if (response.data.valid.email_used === true) {
            this.setState({
              showAlert: true,
              textAlert: 'Cette adresse email existe déjà',
              classAlert: 'alert-danger',
            });
            inputColorWhenError('email');
          } else {
            this._updateProfil(event);
          }
          this._majProfil(true);
        }).catch((error) => {
          this.setState({
            showAlert: true,
            textAlert: error.response.data.message,
            classAlert: 'alert-danger',
          });
          this._majProfil(true);
        });
    } else if (this.state.confirmEmail === '') {
      if (this.state.oldEmail !== this.state.customer.email) {
        this.setState({
          showAlert: true,
          textAlert: 'Veuillez confirmer votre adresse email',
          classAlert: 'alert-danger',
        });
        inputColorWhenError('confirmEmail');
        this._majProfil(true);
      } else {
        this._updateProfil(event);
      }
    } else {
      this.setState({
        showAlert: true,
        textAlert: 'Les adresses mail ne sont pas identiques',
        classAlert: 'alert-danger',
      });
      this._majProfil(true);
    }
  }

  componentWillMount() {
    this._getCustomer();
    this._getTransporteurs();
    this._getFeatureContratsRGPD();
  }

  componentDidMount() {
    this._fetchFeaturePassword();
  }

  /**
   * Récupère l'état de la feature compte_motdepasse_robuste
   * @private
   */
  _fetchFeaturePassword() {
    axios.get(`${getHostApi()}/shops/features/compte_motdepasse_robuste`, getRequestConfig()).then((response) => {
      this.featurePassword = response.data.feature;
    }).catch((error) => {
      console.log(error);
    });
  }

  onOpenModal = (contrat : string = '') => {
    let contenu = '';
    if (event && contrat !== '') {
      for (const [key] of Object.entries(this.state.contrats)) {
        if (contrat === key && this.state.modalContent === '' && contenu === '') {
          contenu = '<h1 style="margin: 0 0 20px 0">' +
            (this.state.contrats as any)[key]['libelle'] +
            '</h1>' + (this.state.contrats as any)[key]['content'];
        }
      }
    }
    this.setState({
      modal: !this.state.modal,
      modalContent: contenu,
    });
  }

  private onShowHidePassword(id: string) {
    this.showHidePassword = !this.showHidePassword;
    const password : any = document.getElementById(id);
    if(password) {
      password.setAttribute('type', this.showHidePassword ? "text" : "password");
    }
  }

  private onResetPassword(id: string) {
    const password : any = document.getElementById(id);
    if(password) {
      password.setAttribute('value', '');
      password.value = '';
      if(id === 'confirmPassword') {
        this.setState({ confirmPassword: '' });
      } else if(id === 'password') {
        this.setState({ newPassword: '' });
      }
    }
    this.verifPassword('');
  }

  private onCapsLockMode(event: any, name: string) {
    const value = name == 'majLockMode' ? this.state.majLockMode : this.state.majLockModeConf;
    if(event.keyCode == 20) {
      this.setState({
        ...this.state,
        [name]: !value
      });
    }
  }

  render() {

    const renderFirstName = () => {
      return (
        <div className="d-flex align-items-center mb-3">
          {renderLabel('Prénom* :')}
          {renderInput('text', 'firstname', this.state.customer.firstname, this._onUpdateInput)}
        </div>
      );
    };

    const renderLastName = () => {
      return (
        <div className="d-flex align-items-center mb-3">
          {renderLabel('Nom* :')}
          {renderInput('text', 'lastname', this.state.customer.lastname, this._onUpdateInput)}
        </div>
      );
    };

    const renderEmail = () => {
      return (
        <div className="d-flex align-items-center mb-3">
          {renderLabel('Email* :')}
          {renderInput('email', 'email', this.state.customer.email, this._onUpdateInput)}
        </div>
      );
    };

    const renderConfirmEmail = () => {
      return (
        <div className="d-flex align-items-center mb-3">
          {renderLabel('Confirmation de l\'email* :')}
          {renderInput('email', 'confirmEmail', this.state.confirmEmail, this._onUpdateInput)}
        </div>
      );
    };

    const renderOldPassword = () => {
      return (
        <div className="d-flex align-items-center mb-3">
          {renderLabel('Ancien mot de passe :')}
          {renderInput('password', 'oldPassword', this.state.oldPassword, this._onUpdateInput)}
        </div>
      );
    };

    const renderMajLockInfo = () => {
      return (
          <div className="d-flex align-items-center mb0">
            {renderLabel('')}
            <div className={"inputPasswordForm col-md-6 text-left"}>
              <span className={"capsLockInfos"}>Majuscules activées</span>
            </div>
          </div>
      );
    }

    const renderPassword = () => {
      return (
          <>
            <div className="d-flex align-items-center mb-3">
              {renderLabel('Nouveau mot de passe :')}
              <div className={"inputPasswordForm col-md-6 text-left inputPasswordFormProfil"}>
                <input id={'password'} onChange={this._onUpdateInput} type={'password'} name={'newPassword'}
                       value={this.state.newPassword} autoComplete={'off'} onKeyUp={(e:any) => this.onCapsLockMode(e, 'majLockMode')} />
                {this.featurePassword && this.state.newPassword && this.state.newPassword.length > 0 &&
                <>
                    <div onClick={() => { this.onResetPassword('password'); }}
                         className={"resetPasswordForm"}>
                        <Icons
                            icon="close" size={30} title="Retirer le mot de passe"/>
                    </div>
                    <div onClick={() => { this.onShowHidePassword('password'); }} className={"eyePasswordForm eyePasswordFormProfil"}>
                        <Icons
                            icon="remove_red_eye" size={20} title="Afficher/Masquer le mot de passe"/>
                    </div>
                </>
                }
              </div>
            </div>
            {this.featurePassword && this.state.majLockMode && renderMajLockInfo()}
            {this.displayPasswordInfos && this.featurePassword ?
                <div className="d-flex align-items-center mb-3">
                  <div className={"col-md-6"}/>
                  <PasswordInfosForm lstCheckbox={this.passwordInfos} monCompte={true} />
                </div>
                : null}
          </>
      );
    };

    const renderConfirmPassword = () => {
      return (
          <>
            <div className="d-flex align-items-center mb-3">
              {renderLabel('Confirmation du mot de passe :')}
              <div className={"inputPasswordForm col-md-6 text-left inputPasswordFormProfil"}>
                <input id={'confirmPassword'} onChange={this._onUpdateInput} type={'password'} name={'confirmPassword'}
                       value={this.state.confirmPassword} autoComplete={'off'} onKeyUp={(e:any) => this.onCapsLockMode(e, 'majLockModeConf')} />
                {this.featurePassword && this.state.confirmPassword && this.state.confirmPassword.length > 0 &&
                <>
                    <div onClick={() => { this.onResetPassword('confirmPassword'); }}
                         className={"resetPasswordForm"}>
                        <Icons
                            icon="close" size={30} title="Retirer le mot de passe"/>
                    </div>
                    <div onClick={() => { this.onShowHidePassword('confirmPassword'); }} className={"eyePasswordForm"}>
                        <Icons
                            icon="remove_red_eye" size={20} title="Afficher/Masquer le mot de passe"/>
                    </div>
                </>
                }
              </div>
            </div>
          {this.featurePassword && this.state.majLockModeConf && renderMajLockInfo()}
         </>
      );
    };

    const renderModalContrats = () => {
      const contenu = this.state.modalContent;
      const createMarkup = () => ({__html: contenu});
      return (
          <Modal classNames={{overlay: 'bootstrap-container'}} open={this.state.modal} onClose={this.onOpenModal} center>
            <div className="p-5" dangerouslySetInnerHTML={createMarkup()}>
            </div>
          </Modal>
      );
    };

    const renderContrats = (type : string) => {
      const html = [];
      let nbrContrats = 0;
      let nbrContratsAccepted = 0;
      let nameOfContrat = '';
      for (const [, elt] of Object.entries(this.state.contrats)) {
        if (type === 'obligatoires' && elt.obligatoire === '1') {
          if (elt.accepted) {
            nbrContratsAccepted = nbrContratsAccepted + 1;
          }
          nameOfContrat = nbrContrats === 0 ? elt.nom  : nameOfContrat + '|' + elt.nom ;
          nbrContrats = nbrContrats + 1;
          html.push(
            <span style={{ cursor: 'pointer' }} onClick={e => this.onOpenModal(elt.nom)} >{elt.accord_client_libelle}</span>
          );
        } else if (type === 'facultatifs' && elt.obligatoire === '0') {
          const stateChecked = elt.accepted === true ? '1' : false;
          nameOfContrat = elt.nom;
          html.push(
            <div className="d-flex text-left  mb-3">
              {/* eslint-disable-next-line no-constant-condition */}
              {(this.state.cmdEnCours && false) ? <div className={'text-left checkBoxRGPD'}><input type="checkbox" checked={elt.accepted} className={'not-allowed'} title="La modification n'est pas autorisée lorsqu'une de vos commandes est en cours de traitement"/></div> : renderInput('checkbox', nameOfContrat, stateChecked, this._onCheckedInput, 'checkBoxRGPD')}
              <label className="nobold">
                <span style={{ cursor : 'pointer' }}  onClick={e => this.onOpenModal(elt.nom)}>
                  {elt.accord_client_libelle}
                </span>
              </label>
            </div>);
        }
      }
      if (type === 'facultatifs') {
        return (
          <>
          {html}
          </>
        );
      }
      if (type === 'obligatoires') {
        const stateChecked = nbrContrats === nbrContratsAccepted ? '1' : false;
        // On affiche seulement les contrats facultatifs
        //eslint-disable-next-line
        if (nbrContrats > 0 && false) {
          return (
            <div className="d-flex text-left  mb-3">
              {this.state.cmdEnCours ?
                <div className={'text-left checkBoxRGPD'}><input type="checkbox" checked className={'not-allowed'}
                                                          title="La modification n'est pas autorisée lorsqu'une de vos commandes est en cours de traitement"/>
                </div> : renderInput('checkbox', nameOfContrat, stateChecked, this._onCheckedInput, 'checkBoxRGPD')}
              <label className="nobold"> {html}</label>
            </div>
          );
        }
      }
    };

    const renderProfil = () => {
      return (
        <div className="mb-4 divFormProfil">
          {this.state.listCustomerTypes.length > 0 && (
            <div className="d-flex align-items-center mb-3">
              {renderLabel('Activité :')}
              <div className="col-md-6 text-left">
                <select
                  className="w100"
                  value={this.state.customer.customerType.id}
                  onChange={(e) => this.setState((state) => {
                    state.customer.customerType.id = parseInt(e.target.value);
                    return state;
                  })}
                >
                  {this.state.listCustomerTypes.map((type) => (
                    <option key={type.id} value={type.id}>{type.label}</option>
                  ))}
                </select>
              </div>
            </div>
          )}
          {renderFirstName()}
          {renderLastName()}
          {renderEmail()}
          {renderConfirmEmail()}
          {renderOldPassword()}
          {renderPassword()}
          {renderConfirmPassword()}
          <div className={'px-md-5 px-4 py-2 containerContrats lightgrey font11'}>
            {this.state.activateContratsRGPD ? renderContrats('obligatoires') : ''}
            {this.state.activateContratsRGPD ? renderContrats('facultatifs') : ''}
          </div>
          {this.state.activateContratsRGPD ? renderModalContrats() : ''}
        </div>
      );
    };

    const renderFormProfil = () => {
      return (
        <div className="formProfil p-3 text-center border mx-auto">
          <form>
            {renderProfil()}
            {renderAlert(this.state.showAlert, this.state.classAlert, this.state.textAlert)}
            <button onClick={this._isEmailValid}
                    className="profilButton bg-blue border-0 py-1 px-3 white w-75 reset-button buttonPrimary">
              <span id="intituleBtn">Mettre à jour <span>mes données personnelles</span></span>
              <span className="d-none" id="loaderBtn">
                Chargement ...
              </span>
            </button>
          </form>
        </div>
      );
    };

    return (
      <div>
        {renderTitleH1('profil', 'Mon profil')}
        {renderFilArianne('', 'Mon profil')}
        {renderFormProfil()}
      </div>
    );
  }
}
